/* eslint-disable quotes */
import { ILiteral, LiteralParams } from 'utils/localeText'

// Keys from the server translation catalog. Only English fallbacks belong in the app.
export const agentLiterals = {
  ag_agent: { value: 'ag_agent', fallback: 'Agent' },
  ag_your_ai_ass: { value: 'ag_your_ai_ass', fallback: 'Your workspace assistant' },
  schedule: { value: 'schedule', fallback: 'Schedule' },
  ag_no_sch: { value: 'ag_no_sch', fallback: 'No schedules yet' },
  ag_new_sch: { value: 'ag_new_sch', fallback: 'New schedule' },
  edit: { value: 'edit', fallback: 'Edit' },
  ag_del_sch: { value: 'ag_del_sch', fallback: 'Delete schedule?' },
  ag_del_sch_desc: { value: 'ag_del_sch_desc', fallback: 'Previous replies will stay in your conversation.' },
  ag_sch_stop: { value: 'ag_sch_stop', fallback: 'This schedule will stop running.' },
  ag_sch_tz: { value: 'ag_sch_tz', fallback: 'Schedule timezone' },
  back_button: { value: 'back_button', fallback: 'Back' },
  noItems: { value: 'noItems', fallback: 'Loading data' },
  local_auth_button: { value: 'local_auth_button', fallback: 'Try again' },
  ag_max_sch: { value: 'ag_max_sch', fallback: 'Maximum 20 schedules' },
  ag_sch_not_found: { value: 'ag_sch_not_found', fallback: 'Schedule not found' },
  ag_sch_choose: { value: 'ag_sch_choose', fallback: 'Choose a schedule in the sidebar, or create a new one.' },
  ag_saving: { value: 'ag_saving', fallback: 'Saving…' },
  ag_refresh: { value: 'ag_refresh', fallback: 'Refresh' },
  ag_tz_desc: { value: 'ag_tz_desc', fallback: 'Choose the timezone for your scheduled tasks.' },
  ag_weekdays: { value: 'ag_weekdays', fallback: 'Weekdays' },
  t_weekly: { value: 't_weekly', fallback: 'Weekly' },
  ag_one_time: { value: 'ag_one_time', fallback: 'One-time' },
  frequency: { value: 'frequency', fallback: 'Frequency' },
  ag_custom_sch: { value: 'ag_custom_sch', fallback: 'Custom schedule' },
  t_minutes: { value: 't_minutes', fallback: 'minutes' },
  t_days: { value: 't_days', fallback: 'days' },
  ag_instruction: { value: 'ag_instruction', fallback: 'Instruction' },
  ag_instruction_ph: { value: 'ag_instruction_ph', fallback: 'What should Agent do?' },
  ag_instruction_hint: {
    value: 'ag_instruction_hint',
    fallback: "Write it the way you'd ask a person. Agent has access to sales data and store performance.",
  },
  ag_custom_timing: {
    value: 'ag_custom_timing',
    fallback:
      'This schedule uses custom timing. Editing its instruction keeps that timing. Choose a repeat option to change it.',
  },
  admin_reqiured_field: { value: 'admin_reqiured_field', fallback: 'This field is required' },
  ag_err_days: { value: 'ag_err_days', fallback: 'Select at least one day.' },
  ag_err_minute: { value: 'ag_err_minute', fallback: 'Choose a minute from 0 to 59.' },
  ag_err_time: { value: 'ag_err_time', fallback: 'Choose a valid time.' },
  ag_err_date: { value: 'ag_err_date', fallback: 'Choose a valid date.' },
  ag_err_future: { value: 'ag_err_future', fallback: 'Choose a date and time in the future.' },
  ag_err_next_occ: { value: 'ag_err_next_occ', fallback: 'Choose the next occurrence of this date.' },
  ag_err_save_confirm: {
    value: 'ag_err_save_confirm',
    fallback: 'Save could not be confirmed. Refresh schedules before trying again.',
  },
  ag_err_del_confirm: { value: 'ag_err_del_confirm', fallback: 'Delete could not be confirmed. Refresh schedules.' },
  ag_err_tz_save: {
    value: 'ag_err_tz_save',
    fallback: 'Timezone could not be saved. Check your connection and try again.',
  },
  ag_welcome_h: { value: 'ag_welcome_h', fallback: 'What should we work on?' },
  ag_scroll_latest: { value: 'ag_scroll_latest', fallback: 'Scroll to latest message' },
  close: { value: 'close', fallback: 'Close' },
  ag_dictation_hint: { value: 'ag_dictation_hint', fallback: 'Dictation fills the field — it never sends on its own' },
  ag_voice_unavail: {
    value: 'ag_voice_unavail',
    fallback: 'Voice input is unavailable in this browser. You can type a message.',
  },
  ag_enter_hint: { value: 'ag_enter_hint', fallback: 'Enter to send · Shift+Enter for a new line' },
  ag_stop_insert: { value: 'ag_stop_insert', fallback: 'Stop and insert' },
  ag_start_voice: { value: 'ag_start_voice', fallback: 'Start voice input' },
  send: { value: 'send', fallback: 'Send' },
  ag_mic_denied: {
    value: 'ag_mic_denied',
    fallback: "Microphone permission denied. Allow microphone access in your browser's site settings.",
  },
  ag_wa_btn_connected: { value: 'ag_wa_btn_connected', fallback: 'WhatsApp connected' },
  ag_connect_wa: { value: 'ag_connect_wa', fallback: 'Connect WhatsApp' },
  ag_ideas_hint: {
    value: 'ag_ideas_hint',
    fallback: 'Start with a question. Add a photo or file when you need a closer look.',
  },
  ag_idea_sales: { value: 'ag_idea_sales', fallback: 'Summarize sales' },
  ag_idea_sales_d: {
    value: 'ag_idea_sales_d',
    fallback: "Summarize yesterday's sales and highlight anything that needs attention.",
  },
  ag_idea_compare: { value: 'ag_idea_compare', fallback: 'Compare stores' },
  ag_idea_compare_d: {
    value: 'ag_idea_compare_d',
    fallback: "Compare my stores' performance over the last seven days.",
  },
  ag_idea_plan: { value: 'ag_idea_plan', fallback: 'Plan a summary' },
  ag_idea_plan_d: { value: 'ag_idea_plan_d', fallback: 'Help me set up a recurring sales summary.' },
  ag_msg_label: { value: 'ag_msg_label', fallback: 'Message Agent' },
  ag_search_tz_ph: { value: 'ag_search_tz_ph', fallback: 'Search city, country or UTC offset' },
  ag_use_curr_tz: { value: 'ag_use_curr_tz', fallback: 'Use my current timezone' },
  ag_from_device: { value: 'ag_from_device', fallback: 'From this device' },
  select_group_search_results: { value: 'select_group_search_results', fallback: 'Search results' },
  ag_all_tz: { value: 'ag_all_tz', fallback: 'All timezones' },
  ag_no_tz: { value: 'ag_no_tz', fallback: 'No timezones found' },
  ag_no_tz_hint: { value: 'ag_no_tz_hint', fallback: 'Try another city, country or UTC offset.' },
  ag_clear_search: { value: 'ag_clear_search', fallback: 'Clear search' },
  see_less_sidebar: { value: 'see_less_sidebar', fallback: 'See Less' },
  ag_connected: { value: 'ag_connected', fallback: 'Connected' },
  ag_not_connected: { value: 'ag_not_connected', fallback: 'Not connected' },
  ag_wa_unavail: { value: 'ag_wa_unavail', fallback: 'Load the conversation to connect your WhatsApp account.' },
  ag_wa_going: { value: 'ag_wa_going', fallback: 'Keep the conversation going on WhatsApp.' },
  ag_disconnect_q: { value: 'ag_disconnect_q', fallback: 'Disconnect this WhatsApp account?' },
  cancel: { value: 'cancel', fallback: 'Cancel' },
  ag_disconnect: { value: 'ag_disconnect', fallback: 'Disconnect' },
  code_expired: { value: 'code_expired', fallback: 'Code expired' },
  ag_wa_send_code: { value: 'ag_wa_send_code', fallback: 'Open WhatsApp and send this code to connect with Agent.' },
  ag_get_new_code: { value: 'ag_get_new_code', fallback: 'Get new code' },
  ag_open_wa: { value: 'ag_open_wa', fallback: 'Open WhatsApp' },
  ag_wa_waiting: { value: 'ag_wa_waiting', fallback: 'Waiting for confirmation' },
  ag_scan_phone: { value: 'ag_scan_phone', fallback: 'Scan with your phone' },
  ag_connectors: { value: 'ag_connectors', fallback: 'Connectors' },
  ag_preview_unavailable: { value: 'ag_preview_unavailable', fallback: 'Preview unavailable' },
  ag_expand_img: { value: 'ag_expand_img', fallback: 'Expand image' },
  ag_your_msg: { value: 'ag_your_msg', fallback: 'Your message' },
  ag_agent_msg: { value: 'ag_agent_msg', fallback: 'Agent message' },
  ag_via_wa: { value: 'ag_via_wa', fallback: 'via WhatsApp' },
  ag_scheduled: { value: 'ag_scheduled', fallback: 'Scheduled' },
  ag_copy: { value: 'ag_copy', fallback: 'Copy' },
  ag_copied: { value: 'ag_copied', fallback: 'Copied' },
  ag_copy_unavail: { value: 'ag_copy_unavail', fallback: 'Copy unavailable' },
  ag_feedback_title: { value: 'ag_feedback_title', fallback: 'Report a problem' },
  ag_feedback_question: { value: 'ag_feedback_question', fallback: 'What was wrong with this answer?' },
  ag_feedback_rate: { value: 'ag_feedback_rate', fallback: 'Rate response' },
  ag_feedback_good: { value: 'ag_feedback_good', fallback: 'Good response' },
  ag_feedback_bad: { value: 'ag_feedback_bad', fallback: 'Bad response' },
  ag_feedback_report_title: { value: 'ag_feedback_report_title', fallback: 'Tell us what went wrong' },
  ag_feedback_report_subtitle: {
    value: 'ag_feedback_report_subtitle',
    fallback: 'Your feedback helps Storee Agent get better.',
  },
  ag_feedback_response_label: { value: 'ag_feedback_response_label', fallback: 'Agent response' },
  ag_feedback_expand_response: { value: 'read_more', fallback: 'Read more' },
  ag_feedback_collapse_response: { value: 'read_less', fallback: 'Read less' },
  ag_feedback_report_placeholder: { value: 't_say_something', fallback: 'Say something' },
  ag_feedback_report_submit: { value: 'reset_password_submit_button', fallback: 'Submit' },
  ag_feedback_sent: { value: 'ag_feedback_sent', fallback: 'Thanks — sent to the team' },
  ag_check_status: { value: 'ag_check_status', fallback: 'Check status' },
  ag_drop_hint: { value: 'ag_drop_hint', fallback: 'Drop one image, PDF, CSV or Excel file' },
  ag_one_file: { value: 'ag_one_file', fallback: 'Attach one file per message.' },
  ag_working: { value: 'ag_working', fallback: 'Agent is working…' },
  ag_no_reply: { value: 'ag_no_reply', fallback: 'No reply yet' },
  ag_attachment: { value: 'ag_attachment', fallback: 'Attachment' },
  ag_request: { value: 'ag_request', fallback: 'Request' },
  ag_loaded_req: { value: 'ag_loaded_req', fallback: 'Loaded request' },
  ag_and: { value: 'ag_and', fallback: 'and' },
  ag_the_days: { value: 'ag_the_days', fallback: 'the days you choose' },
  ag_sel_time: { value: 'ag_sel_time', fallback: 'the selected time' },
  ag_sel_date: { value: 'ag_sel_date', fallback: 'the selected date' },
  start_time: { value: 'start_time', fallback: 'Start time' },
  ag_using: { value: 'ag_using', fallback: 'Using' },
  history: { value: 'history', fallback: 'History' },
  save: { value: 'save', fallback: 'Save' },
  date: { value: 'search_feed_date_filter', fallback: 'Date' },
  t_daily: { value: 't_daily', fallback: 'Daily' },
  t_monthly: { value: 't_monthly', fallback: 'Monthly' },
  image: { value: 'image', fallback: 'Image' },
  upload_file: { value: 'upload_file', fallback: 'Upload file' },
  open_camera: { value: 'open_camera', fallback: 'Use camera' },
  admin_phone_number: { value: 'admin_phone_number', fallback: 'Phone number' },
  scheduls: { value: 'scheduls', fallback: 'Schedules' },
  admin_delete_action: { value: 'admin_delete_action', fallback: 'Delete' },
  take_photo: { value: 'take_photo', fallback: 'Take photo' },
  ag_thinking: { value: 'ag_thinking', fallback: 'Thinking' },
  ag_upload_failed: { value: 'ag_upload_failed', fallback: 'Upload failed' },
  ag_drop_alternative: { value: 'ag_drop_alternative', fallback: 'Or drop an image or file into the conversation.' },
  post_attach_file_web_hover: { value: 'post_attach_file_web_hover', fallback: 'Attach file' },
  cover_name: { value: 'cover_name', fallback: 'Upload image' },
  ag_from_computer: { value: 'ag_from_computer', fallback: 'From your computer' },
  ag_camera_preview: { value: 'ag_camera_preview', fallback: 'Camera preview' },
  ag_camera_starting: {
    value: 'ag_camera_starting',
    fallback: 'Opening camera… Allow camera access when your browser asks.',
  },
  ag_camera_failed: {
    value: 'ag_camera_failed',
    fallback: 'Could not open the camera or capture a photo. Check camera access in your browser, or upload a photo.',
  },
  ag_collapse_input: { value: 'ag_collapse_input', fallback: 'Collapse message input' },
  ag_expand_input: { value: 'ag_expand_input', fallback: 'Expand message input' },
  ag_starting: { value: 'ag_starting', fallback: 'Starting…' },
  ag_recording: { value: 'ag_recording', fallback: 'Recording' },
  ag_escape_cancel: { value: 'ag_escape_cancel', fallback: 'Esc to cancel' },
  ag_connection_lost: { value: 'ag_connection_lost', fallback: 'Connection lost' },
  ag_history_incomplete: { value: 'ag_history_incomplete', fallback: 'Some messages may be missing from this view.' },
  ag_code: { value: 'ag_code', fallback: 'Code' },
  ag_table: { value: 'ag_table', fallback: 'Table' },
  ag_recurring: { value: 'ag_recurring', fallback: 'Recurring' },
  ag_hourly: { value: 'ag_hourly', fallback: 'Hourly' },
  see_more_sidebar: { value: 'see_more_sidebar', fallback: 'See More' },
  ag_utc_offsets: { value: 'ag_utc_offsets', fallback: 'UTC offsets' },
  show_all: { value: 'show_all', fallback: 'Show all' },
  ag_saved_custom_timing: { value: 'ag_saved_custom_timing', fallback: 'the saved custom timing' },
  ag_long_term: { value: 'ag_long_term', fallback: 'Long-term link for someone else (e.g. a customer)' },
  ag_generate_long_term: { value: 'ag_generate_long_term', fallback: 'Generate long-term link' },
  ag_connected_to: { value: 'ag_connected_to', fallback: 'Connected to {phone}.' },
  view: { value: 'view', fallback: 'View' },
  uploading_post_media_loading: { value: 'uploading_post_media_loading', fallback: 'Uploading...' },
  ag_go_to_request: { value: 'ag_go_to_request', fallback: 'Go to request: {request}' },
  ag_request_position: { value: 'ag_request_position', fallback: '{label} {index} of {count}' },
  ag_connector_soon: { value: 'ag_connector_soon', fallback: '{name} — coming soon' },
  ag_times_in_zone: { value: 'ag_times_in_zone', fallback: 'Times in {timezone}' },
  ag_minute_number: { value: 'ag_minute_number', fallback: 'Minute {minute}' },
  ag_monthly_timing: { value: 'ag_monthly_timing', fallback: 'Day {day} · {time}' },
  ag_timing_weekly: { value: 'ag_timing_weekly', fallback: 'every {days} at {time}' },
  ag_timing_hourly: { value: 'ag_timing_hourly', fallback: 'every hour at minute {minute}' },
  ag_timing_once: { value: 'ag_timing_once', fallback: 'once on {date} at {time}' },
  ag_timing_daily: { value: 'ag_timing_daily', fallback: 'every day at {time}' },
  ag_timing_weekdays: { value: 'ag_timing_weekdays', fallback: 'every weekday at {time}' },
  ag_schedule_summary: {
    value: 'ag_schedule_summary',
    fallback: 'Agent will run this {timing}{timezone}, and post the answer into your conversation.',
  },
  ag_err_file_type: { value: 'ag_err_file_type', fallback: 'Choose an image, PDF, CSV or Excel file.' },
  ag_err_upload_confirm: {
    value: 'ag_err_upload_confirm',
    fallback: 'Upload could not be confirmed. Remove this attachment and select the file again.',
  },
  ag_err_remove_attachment: {
    value: 'ag_err_remove_attachment',
    fallback: 'Unable to remove the attachment. Try removing it again.',
  },
  ag_err_credentials: { value: 'ag_err_credentials', fallback: 'Scheduled runs could not refresh their credentials.' },
  ag_err_load_agent: {
    value: 'ag_err_load_agent',
    fallback: 'Unable to load Agent or its history. Try loading again.',
  },
  ag_err_uncertain: {
    value: 'ag_err_uncertain',
    fallback:
      'The result could not be confirmed. Your message is saved. Check history before sending again; Agent may still be working.',
  },
  ag_err_run_failed: { value: 'ag_err_run_failed', fallback: 'Agent could not complete this run.' },
  ag_err_rejected: { value: 'ag_err_rejected', fallback: 'Unable to send. Your draft is saved. Please try again.' },
  ag_feedback_error: { value: 'ag_feedback_error', fallback: "Couldn't send your report. Please try again." },
  ag_err_load_schedules: { value: 'ag_err_load_schedules', fallback: 'Schedules could not be loaded.' },
  ag_err_whatsapp_check: {
    value: 'ag_err_whatsapp_check',
    fallback: 'The WhatsApp connection status could not be confirmed. Check its status before trying again.',
  },
  ag_lightbox_prev: { value: 'ag_lightbox_prev', fallback: 'Previous image' },
  ag_lightbox_next: { value: 'ag_lightbox_next', fallback: 'Next image' },
  ag_zoom_in: { value: 'ag_zoom_in', fallback: 'Zoom in' },
  ag_zoom_out: { value: 'ag_zoom_out', fallback: 'Zoom out' },
  ag_download: { value: 'ag_download', fallback: 'Download' },
  ag_calendar: { value: 'ag_calendar', fallback: 'Calendar' },
  ag_err_file_size: {
    value: 'ag_err_file_size',
    fallback: 'This file is too large. The maximum size for .{extension} files is {size}.',
  },
} as const

// Translate only application-generated errors. Conversation content never passes through this lookup.
const errorKeys = Object.keys(agentLiterals).filter(
  (key) => key.startsWith('ag_err_') || key === 'ag_one_file' || key === 'admin_reqiured_field'
) as Array<keyof typeof agentLiterals>
const errors = new Map<string, ILiteral>(errorKeys.map((key) => [agentLiterals[key].fallback, agentLiterals[key]]))
// The shared file validator emits this fixed error before Agent can normalize it.
errors.set('This file type is not supported. Choose a different file.', agentLiterals.ag_err_file_type)
export function agentErrorText(message: string): { text: ILiteral; params?: LiteralParams } {
  const size = message.match(/^This file is too large\. The maximum size for \.(.+) files is (.+)\.$/)
  if (size) return { text: agentLiterals.ag_err_file_size, params: { extension: size[1], size: size[2] } }
  return { text: errors.get(message) || { value: '', fallback: message } }
}
